import RelatorioEmDesenvolvimento from "../../../components/RelatorioEmDesenvolvimento";

const AlertasPred = () => (
  <RelatorioEmDesenvolvimento
    titulo="Alertas Preditivos"
    descricao="Vai depender de um modelo de previsão treinado com histórico real da fazenda."
  />
);

export default AlertasPred;
